import { render, staticRenderFns } from "./shipped.vue?vue&type=template&id=07d3b926&scoped=true"
import script from "./shipped.vue?vue&type=script&lang=js"
export * from "./shipped.vue?vue&type=script&lang=js"
import style0 from "./shipped.vue?vue&type=style&index=0&id=07d3b926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3b926",
  null
  
)

export default component.exports